var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 392.001,
    viewBox: "0 0 180 392.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.882,
    y1: 0.186,
    x2: 0.118,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2450ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4014bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.118,
    y1: 0.186,
    x2: 0.882,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee6f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1365 -5154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1374,454h0a157.158,157.158,0,0,0,31.44-3.169,155.218,155.218,0,0,0,29.283-9.09,156.033,156.033,0,0,0,26.5-14.383,157.131,157.131,0,0,0,23.088-19.049,157.121,157.121,0,0,0,19.049-23.088,156,156,0,0,0,14.383-26.5,155.211,155.211,0,0,0,9.09-29.283A157.147,157.147,0,0,0-1218,298a157.147,157.147,0,0,0-3.169-31.44,155.214,155.214,0,0,0-9.09-29.283,156,156,0,0,0-14.383-26.5,157.122,157.122,0,0,0-19.049-23.088,157.12,157.12,0,0,0-23.088-19.049,156.031,156.031,0,0,0-26.5-14.383,155.215,155.215,0,0,0-29.283-9.09A157.158,157.158,0,0,0-1374,142V454Z",
    transform: "translate(2739 5092)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(1465 5154)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleRight);
export default __webpack_public_path__ + "static/media/bubble_right.ae636689f678501e3bf5daf7c0f7ae74.svg";
export { ForwardRef as ReactComponent };